import { message } from 'antd';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { mellIcon, usdtIcon } from '../../../../assets';

import { setAuth } from '../../../../store/auth/auth.slice';
import { TRootState } from '../../../../store/store';
import { transport } from '../../../../utils/constants';
import { getToken, haptic, Haptick, isRpcError } from '../../../../utils/helper';
import { IAsset, IWalletServiceProps } from '../../types';
import { WalletClient } from '../../../../generated/mlmbox/client/finance/wallet.client';
import { Empty } from '../../../../generated/google/protobuf/empty';
import Button from '../../../../components/Button/Button';

export function WalletService(props: IWalletServiceProps) {
    const wallet = useSelector((state: TRootState) => state.wallet.value);

    const dispatch = useDispatch();
    const { t } = useTranslation();

    const handleAssetAction = (actionType: 'withdraw' | 'deposit') => {
        const walletClient = new WalletClient(transport);

        walletClient
            .processingsAll(Empty, { meta: { authorization: getToken() } })
            .then(({ response }) => {
                const assetsList: IAsset[] = [];

                response.items.forEach((el) => {
                    el.assets.forEach((asset) => {
                        if (asset.assetId === props.assetId) {
                            assetsList.push({
                                ...asset,
                                processingName: el.processingName,
                                processingId: el.processingId,
                            });
                        }
                    });
                });

                const allowedAction =
                    actionType === 'withdraw'
                        ? assetsList.find((el) => el.settingsWithdrawalEnabled)
                        : assetsList.find((el) => el.settingsDepositEnabled);

                if (!allowedAction) {
                    message.destroy();
                    message.error(t(actionType === 'withdraw' ? 'errors.not_withdraw' : 'errors.not_deposit'));
                    return;
                }

                if (actionType === 'withdraw') {
                    const userAsset = wallet.assets.find((el) => el.assetId === props.assetId);
                    const availableAmount = userAsset?.withdrawalCapacity?.available;

                    if (!userAsset || Number(availableAmount) === 0) {
                        message.destroy();
                        message.error(t('errors.not_money'));
                        return;
                    }
                    props.setWithdraw(allowedAction);
                } else if (actionType === 'deposit') {
                    walletClient
                        .depositAddress(
                            { processingId: allowedAction.processingId },
                            { meta: { authorization: getToken() } }
                        )
                        .then(({ response }) => {
                            props.setDeposit({ ...allowedAction, address: response.address });
                        })
                        .catch((err) => {
                            if (isRpcError(err)) {
                                const errorMessage =
                                    err.message === 'PROCESSING_NOT_FOUND'
                                        ? 'errors.asset_channel_unknown'
                                        : 'errors.not_deposit';
                                message.error(t(errorMessage));
                                return;
                            }
                        });
                }
            })
            .catch((err) => {
                if (isRpcError(err)) {
                    if (err.code === '16') {
                        dispatch(setAuth({ isAuth: '' }));
                        return;
                    }
                }
            });
    };

    return (
        <>
            <div className="wallet-service">
                <div className="wallet-service__info">
                    <div className="wallet-service__info--currency">
                        {props.assetId === 1 ? (
                            <img
                                src={usdtIcon}
                                alt="usdtIcon"
                            />
                        ) : (
                            <img
                                src={mellIcon}
                                alt="mellIcon"
                            />
                        )}
                        <div className="box">
                            <h3>{props.assetId === 1 ? 'USDT' : '$MOON'}</h3>
                        </div>
                    </div>
                    <div className="wallet-service__info--balance">
                        <div className="box box-right">
                            <h3>
                                {(props.assetId === 1
                                    ? Number(wallet.assets[props.assetId - 1].assetBalance)
                                    : parseInt(wallet.assets[props.assetId - 1].assetBalance)
                                ).toLocaleString()}

                                {props.assetId === 1 ? <span>$</span> : <></>}
                            </h3>
                        </div>
                    </div>
                </div>

                <div className="wallet-service__btns">
                    {props.assetId === 2 && (
                        <Button
                            title={t('stacking')}
                            onClick={props.setContract}
                        />
                    )}
                    {props.assetId === 2 && (
                        <Button
                            title={t('buy_b')}
                            onClick={() => {
                                props.setExchange('buy');
                            }}
                        />
                    )}
                    {/* {props.assetId === 2 && (
                        <button
                            onClick={() => {
                                Haptick(haptic.light);
                                props.setExchange('sell');
                            }}>
                            {t('sell_b')}
                        </button>
                    )} */}

                    <Button
                        title={t('wallet.btns.withdraw')}
                        onClick={() => {
                            Haptick(haptic.light);
                            handleAssetAction('withdraw');
                        }}
                    />

                    {props.assetId === 1 && (
                        <Button
                            title={t('wallet.btns.deposit')}
                            onClick={() => {
                                Haptick(haptic.light);
                                handleAssetAction('deposit');
                            }}
                        />
                    )}

                    {props.assetId === 1 && (
                        <Button
                            title={t('wallet.btns.transfer')}
                            onClick={() => {
                                Haptick(haptic.light);
                                props.setTransfer(true);
                            }}
                        />
                    )}

                    {/* {props.assetId === 2 && (
                        <button
                            onClick={() => {
                                Haptick(haptic.light);
                                props.setBonusOpen(true);
                            }}>
                            {t('bonus_title')}
                        </button>
                    )} */}
                </div>
            </div>
        </>
    );
}
